import { isEmpty, isNil } from 'lodash';

const checkFormUpsertValidation = ({ formField, isShowAllFields }) => {
  let isValid = false;

  if (isShowAllFields) {
    isValid =
      !isEmpty(formField?.appliedAt?.toISOString()) &&
      !isEmpty(formField?.brandId) &&
      !isNil(formField?.targetGmv) &&
      !isEmpty(formField?.targetViewsShopee) &&
      !isNil(formField?.targetCtrShopee) &&
      !isNil(formField?.targetCtorShopee) &&
      !isNil(formField?.targetAovShopee) &&
      !isEmpty(formField?.targetViewsTiktok) &&
      !isNil(formField?.targetCtrTiktok) &&
      !isNil(formField?.targetCtorTiktok) &&
      !isNil(formField?.targetAovTiktok) &&
      !isNil(formField?.targetErrTiktok);
  }

  return isValid;
};

export default checkFormUpsertValidation;
